import { AppState } from '~src/app/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { editFlowTask } from '~src/flow/actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '~src/flow/models/RunFlowTaskInfo';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { hasRunNowPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

export const EditFlowTaskAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksEdit,
  translateName: Messages.editTask_action,
  isVisible: (targetItems: RunFlowTaskInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length === 1 && hasRunNowPermission(state);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => editFlowTask(targetItems)
};
